import { ETHNICITIES, GENDERS, RACES } from "../../../../utilities/dictionaryConstants";
import { DEFAULT_COUNTRY, TAB1 } from "../../../../utilities/staticConfigs";

const patientBasicInfo=()=>({
    locked_by_name: "",
    locked: false,
    patient_editable: true,
    patient_inactive: false,
    profile_locked: "",
    patient: "",
    custom_patient_id: "",
    last_name: "",
    first_name: "",
    middle_name: "",
    suffix: "",
    gender: "",
    date_of_birth: "",
    date_of_death: "",
    patient_type: "",
    ssn: "",
    other_id: "",
    active: true,
    detail_ids: {
        patient_info: "",
        billing_info: "",
    },
})
const patientInfoData=()=>({
    id: "",
    active: true,
    authorized_contact: 1,
    cell_phone: "",
    email: "",
    emergency_as_guarantor: true,
    emergency_cell_phone: "",
    emergency_email: "",
    emergency_first_name: null,
    emergency_home_phone: null,
    emergency_last_name: null,
    emergency_location: null,
    emergency_location_data: {
        city: "",
        country: "",
        state: "",
        street1: "",
        street2: "",
        zip_code: "",
    },
    emergency_middle_name: null,
    emergency_relationship: "",
    emergency_relationship_name: "",
    emergency_suffix: null,
    emergency_work_phone: "",
    ethnicity: 1,
    facility_location: null,
    guarantor_address_as_patient: false,
    guarantor_cell_phone: "",
    guarantor_email: null,
    guarantor_first_name: null,
    guarantor_home_phone: null,
    guarantor_last_name: null,
    guarantor_location: null,
    guarantor_location_data: {
        city: "",
        country: "",
        state: "",
        street1: "",
        street2: "",
        zip_code: "",
    },
    guarantor_middle_name: null,
    guarantor_relationship: "",
    guarantor_relationship_name: "",
    guarantor_suffix: null,
    guarantor_work_phone: "",
    home_phone: "",
    location: "",
    location_data: {
        city: "",
        country: DEFAULT_COUNTRY,
        state: "",
        street1: "",
        street2: "",
        zip_code: "",
    },
    patient: "",
    patient_status: true,
    practice_location: "",
    preferred_language: "",
    race: "",
    referring_provider: null,
    referring_provider_group: "",
    rendering_provider: null,
    work_phone: "",
    service_location_value: "",
    service_location: {},
})
const otherBillingDetails=()=>({
    accident_date: "",
    accident_location_id: "",
    accident_type_id: "",
    other_accident: "",
    assignment_benefit_id: "",
    accept_assignments: 1,
    initial_treatment_date: "",
    admission_date: "",
    last_menstural_date: "",
    cliam_casuality_number: "",
    cpt1: "",
    cpt2: "",
    cpt3: "",
    cpt4: "",
    cpt5: "",
    cpt6: "",
    cpt7: "",
    cpt8: "",
    cpt9: "",
    cpt10: "",
    cpt11: "",
    cpt12: "",
    dx1: "",
    dx2: "",
    dx3: "",
    dx4: "",
    dx5: "",
    dx6: "",
    dx7: "",
    dx8: "",
    dx9: "",
    dx10: "",
    dx11: "",
    dx12: "",
})


const defaultValidationObj = (prefix) => {
    const obj = {};
    for (let i = 1; i <= 12; i++) obj[`${prefix}${i}`] = "";
    return obj;
  };
  

export const initialState = {
    formWarningStatus: false,
    patientBasicInfo: patientBasicInfo(),
    patientInfoData: patientInfoData(),
    otherBillingDetails:otherBillingDetails(),
    emergencySelf: false,
    emergencyRelationShip: "",
    guaratorSelf: false,
    streetValidity: {
        street: false,
        guarantorStreet: false,
        emergencyStreet: false
    },
    renderingProvider: [],
    referringProvider: [],
    serviceLocations: [],
    typeOfAccident: [],
    listOfLocation: [],
    patientTypes: [],
    languagesList: [],
    relationList: [],
    icdList: [],
    cptList: [],
    referringProviderGroupList: [],
    genderList: GENDERS,
    ethnicityList: ETHNICITIES,
    raceList: RACES,
    isLoading: false,
    isSaveLoading:false,
    diagnosisValidation: defaultValidationObj("dx"),
    cptValidation: defaultValidationObj("cpt"),
    cptValidated:false,
    cptduplicated:false,
    diagnosisduplicated:false,
    diagnosisesValidated:false,
    error: "",
    accidentNoId: "",
    activeTab: TAB1,
    inactivePatientModal: false,
    inactivePatientAlertModal: false,
    patientValidationModal: false,
    patientMergeModal: false,
    mergePatientSelected: [],
    patientMergeList: [],
    isCheckedAll: false,
    activePatientModal: false,
    patientFormWarnings: [
        {
            "Last Name": "",
            "First Name": "",
            Gender: "",
            DOB: "",
            "Patient Type": "",
        },
        {
            tabName: "Patient Info",
            Street1: "",
            City: "not-set",
            State: "not-set",
            Zip: "",
            "Invalid Zip": "true",
            "Rendering Provider": "not-set",
        },
        {
            tabName: "Insurance Info",
            "Insurance Details": "",
        },
    ],
    patientInfoValidEmail: false,
    patientInfoValidEmergencyEmail:false,
    patientInfoValidGuarantorEmail:false,
    disableGuarantorAddressFields: false,
    isValidSSN: true,
    notifyMessage: "",
    showNotification: false,
    statusTag: "",
    billingInfoPks: [],
    loading: false,
    assignmentBenifit: [],
    dataError:false,
    showInsuranceAddnew:false,
    isInsuranceAdded:false,
    isClaimClose:false,
    patientLedger: {
        isOpen: false,
        loading: false,
        isClaimLoading: false,
        patientId: null,
        patientPaymentSummary: {},
        patientCredit:[],
        insuranceCredit:[],
        patientLeadgerSummary:{},
        claimsData: [],
        expandedClaims: {},
        insurance_tiers_summary:[],
        error: null,
    },

    duplicateDataSet: {
        patientBasicInfo: patientBasicInfo(),
        patientInfoData: patientInfoData(),
        otherBillingDetails: otherBillingDetails(),
    },
}